import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input, Radio, Checkbox, Button, message, Select } from "antd";
import Icon1 from "../../../Assets/Icons/send.svg";
import Icon2 from "../../../Assets/Icons/book_ribbon.svg";
import Icon3 from "../../../Assets/Icons/settings.svg";
import "./style.css";
import { createApiKey } from "../../../API/apiKeys";
import { getAllServers } from "../../../API/server";

const CreateApiKey = () => {
  const [form] = Form.useForm();
  const serverAccess = Form.useWatch("server_access", form);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [servers, setServers] = useState([]);

  const fetchAllServers = async () => {
    try {
      setLoading(true);
      const response = await getAllServers();
      if (Math.floor(response?.status / 100) === 2) {
        const data = response?.data || [];
        setServers(data);
      } else {
        message.error("Unexpected response from server.");
      }
    } catch (error) {
      message.error("Failed to fetch dashboard data Email Volume.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllServers();
  }, []);

  const handleGenerate = async (values) => {
    const { permissions, ...rest } = values;
    const payload = {
      ...rest,
      can_send: values.permissions?.includes("send") || false,
      can_read: values.permissions?.includes("read") || false,
      can_manage: values.permissions?.includes("manage") || false,
    };
    try {
      setLoading(true);
      const response = await createApiKey(payload);
      if (Math.floor(response?.status / 100) === 2) {
        const apiKey = response?.data?.data?.key;
        message.success("API Key saved successfully!");
        form.resetFields();
        navigate("/api-key-generated", { state: { apiKey } });
      } else {
        message.error(JSON.stringify(response?.data?.errors));
      }
    } catch (error) {
      message.error("Failed to create server");
    } finally {
      setLoading(false);
    }
    setLoading(false);
  };

  const handleResetForm = () => {
    form.resetFields();
  };

  return (
    <div className="create-api">
      <div className="container">
        <div className="top-container">
          <div className="top-content">
            <div className="title">Create New API Key</div>
            <div className="sub-title">
              Configure access and permissions for your new credential.
            </div>
          </div>
          <div className="border"></div>

          <div className="second-container">
            <Form
              form={form}
              layout="vertical"
              onFinish={handleGenerate}
              className="api-form"
            >
              <Form.Item
                label="Key Name"
                name="name"
                rules={[{ required: true, message: "Please enter key name" }]}
              >
                <Input placeholder="smtp.example.com" />
              </Form.Item>
              <div className="second-border"></div>

              <div className="server-access">
                <div className="title">Server Access</div>
                <div className="server-options">
                  <Form.Item name="server_access" initialValue="all">
                    <Radio.Group style={{ width: "100%" }}>
                      <div className="option">
                        <Radio value="all" style={{ width: "100%" }}>
                          <div className="radio-label">
                            <b>All Server</b>
                            <div className="radio-desc">
                              Grant access to all current and future servers
                            </div>
                          </div>
                        </Radio>
                      </div>

                      <div className="option">
                        <Radio value="selected" style={{ width: "100%" }}>
                          <div className="radio-label">
                            <b>Selected Server</b>
                            <div className="radio-desc">
                              Restrict access to a specific server instance
                            </div>
                          </div>
                        </Radio>
                      </div>
                    </Radio.Group>
                  </Form.Item>

                  {/* Show Select when selected */}
                  {serverAccess === "selected" && (
                    <Form.Item
                      name="smtp_server"
                      label="Select Server"
                      rules={[
                        { required: true, message: "Please select a server" },
                      ]}
                    >
                      <Select placeholder="Select a server">
                        {servers?.map((server) => (
                          <Select.Option key={server.id} value={server.id}>
                            {server.host}:{server.port}{" "}
                            {server.use_tls ? "(TLS)" : "(SSL)"}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  )}
                </div>
              </div>

              <div className="second-border"></div>
              <div className="permissions">
                <div className="permission-title">Permissions</div>
                <Form.Item
                  name="permissions"
                  rules={[
                    {
                      required: true,
                      message: "Please select at least one permission",
                      type: "array", // important for Checkbox.Group
                    },
                  ]}
                >
                  <Checkbox.Group>
                    <div className="permission-grid">
                      <div className="permission-card">
                        <div className="wrapper">
                          <img
                            src={Icon1}
                            alt="Send"
                            className="permission-icon"
                          />
                          <Checkbox value="send"></Checkbox>
                        </div>
                        <div className="permission-text">
                          <b>Send</b>
                          <div className="permission-desc">
                            Allow sending emails via API
                          </div>
                        </div>
                      </div>

                      <div className="permission-card">
                        <div className="wrapper">
                          <img
                            src={Icon2}
                            alt="Read"
                            className="permission-icon"
                          />
                          <Checkbox value="read"></Checkbox>
                        </div>
                        <div className="permission-text">
                          <b>Read</b>
                          <div className="permission-desc">
                            Access logs and delivery analytics
                          </div>
                        </div>
                      </div>

                      <div className="permission-card">
                        <div className="wrapper">
                          <img
                            src={Icon3}
                            alt="Manage"
                            className="permission-icon"
                          />
                          <Checkbox value="manage"></Checkbox>
                        </div>
                        <div className="permission-text">
                          <b>Manage</b>
                          <div className="permission-desc">
                            Update server and domain config
                          </div>
                        </div>
                      </div>
                    </div>
                  </Checkbox.Group>
                </Form.Item>
              </div>

              <Form.Item>
                <div className="form-footer">
                  <Button
                    type="default"
                    className="cancel-btn"
                    onClick={handleResetForm}
                  >
                    Cancel
                  </Button>
                  <Button type="primary" htmlType="submit" className="save-btn">
                    Generate API Key
                  </Button>
                </div>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateApiKey;
